import { render } from "./RenderMathQuestion.vue?vue&type=template&id=e7fb5ec6&ts=true"
import script from "./RenderMathQuestion.vue?vue&type=script&lang=ts"
export * from "./RenderMathQuestion.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__